class WtTimeline extends HTMLElement {
  connectedCallback() {
    this.entries = this.querySelectorAll('.wt-timeline__entry');
    this.navItems = this.querySelectorAll('.wt-timeline__nav-item');
    this.navWrap = this.querySelector('.wt-timeline__nav-wrap');
    this.navItems.forEach((btn, i) => {
      btn.addEventListener('click', () => this.activate(i, { scroll: true }));
    });
  }

  activate(index, { scroll = false } = {}) {
    this.entries.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      el.toggleAttribute('inert', !active);
    });
    this.navItems.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      if (active) {
        el.setAttribute('aria-current', 'step');
      } else {
        el.removeAttribute('aria-current');
      }
    });
    if (scroll) this.scrollNavTo(index);
  }

  scrollNavTo(index) {
    const wrap = this.navWrap;
    const item = this.navItems[index];
    if (!wrap || !item) return;
    if (wrap.scrollWidth <= wrap.clientWidth) return;
    const target = item.offsetLeft + item.offsetWidth / 2 - wrap.clientWidth / 2;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    wrap.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
  }

  activateByBlockId(blockId) {
    const idx = [...this.entries].findIndex((e) => e.dataset.blockId === blockId);
    if (idx >= 0) this.activate(idx, { scroll: true });
  }
}

if (!customElements.get('wt-timeline')) {
  customElements.define('wt-timeline', WtTimeline);
}

document.addEventListener('shopify:block:select', (e) => {
  const tl = e.target.closest('wt-timeline');
  if (tl && typeof tl.activateByBlockId === 'function') {
    tl.activateByBlockId(e.detail.blockId);
  }
});
